import React from 'react'
import { Offcanvas } from 'react-bootstrap'
import CreateRoomMaintenanceComponent, { CreateRoomMaintenancePrefill } from './CreateRoomMaintenanceComponent'

interface CreateRoomMaintenanceDialogProps {
    show: boolean
    onClose: () => void
    prefill?: CreateRoomMaintenancePrefill | null
}

const CreateRoomMaintenanceDialog: React.FC<CreateRoomMaintenanceDialogProps> = ({ show, onClose, prefill }) => {
    const handleClose = () => {
        onClose()
    }

    return (
        <Offcanvas show={show} placement="end" onHide={handleClose} style={{ width: '100%' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Create Room Maintenance</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <CreateRoomMaintenanceComponent onClose={handleClose} prefill={prefill} />
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default CreateRoomMaintenanceDialog